import React from 'react';
import { arrayOf, string, shape } from 'prop-types';
import { useSpring, animated } from 'react-spring';
import LinkIcon from 'assets/images/icons/new-window-icon.svg';
import bgSrc from 'assets/images/heroImgCropped.png';
import styles from './Hero.module.scss';

const Hero = ({ overLineText, headerText, ingressText, imageUrl, links }) => {
  const props = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });

  return (
    <animated.div style={props}>
      <div className={styles.heroWrapper}>
        {console.log(imageUrl, bgSrc)}
        <div className={styles.textContent}>
          <div className={styles.infoText}>
            <span className={styles.overlineSpan}>{overLineText}</span>
            <h1 className={styles.mainHeader}>{headerText}</h1>
            <p className={styles.ingressParagraph}>{ingressText}</p>
          </div>
          <ul className={styles.linkList}>
            {links &&
              links.map((link) => (
                <li key={link.text} className={styles.listItem}>
                  <a
                    className={styles.listLink}
                    href={link.url}
                    target={link.target}
                  >
                    <LinkIcon />
                    <p className={styles.linkText}>{link.text}</p>
                  </a>
                </li>
              ))}
          </ul>
        </div>
        <div className={styles.imgContent}>
          <img className={styles.heroImg} src={imageUrl} alt="img" />
        </div>
      </div>
    </animated.div>
  );
};

Hero.propTypes = {
  overLineText: string,
  headerText: string,
  ingressText: string,
  imageUrl: string,
  links: arrayOf(
    shape({
      url: string,
      target: string,
      text: string,
    })
  ),
};

Hero.defaultProps = {
  overLineText: '',
  headerText: '',
  ingressText: '',
  imageUrl: '',
  links: null,
};

export default Hero;
